<template>
  <v-chip
    :outlined="outlined"
    :color="chipColor"
    :disabled="disabled"
    :close="closeable"
    @click:close="$emit('close')"
    @click="$emit('click')"
    :class="{ outlined }"
  >
    <Typography variant="body-2" class="black--text">
      <slot>{{ text }}</slot>
    </Typography>
  </v-chip>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "InputChip",
  components: {
    Typography,
  },
  props: {
    text: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "default",
      validator: (v) => ["default", "brand"].includes(v),
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    closeable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close", "click"],
  computed: {
    chipColor() {
      if (this.outlined) {
        if (this.disabled) {
          return "darkGrey";
        }
        return "brandCyan";
      }
      return this.variant === "brand" ? "brandCyanLight" : "default";
    },
  },
};
</script>
<style scoped>
.outlined {
  border-width: 2px;
}

::v-deep .v-chip__close.v-icon {
  color: var(--v-darkGrey-base) !important;
}
</style>
